export default __webpack_public_path__ + "static/media/NIAS0310.34I-32900_-17924_0.71bc5c7d.jpg";